import { render, staticRenderFns } from "./composite.vue?vue&type=template&id=0c43f9ef&scoped=true&"
import script from "./composite.vue?vue&type=script&lang=js&"
export * from "./composite.vue?vue&type=script&lang=js&"
import style0 from "./composite.vue?vue&type=style&index=0&id=0c43f9ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43f9ef",
  null
  
)

component.options.__file = "composite.vue"
export default component.exports